/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Password_Reset_Link_ExpiredInputs */

const en_mobile_password_reset_link_expired = /** @type {(inputs: Mobile_Password_Reset_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This password reset link has expired or was already used. Request a new one.`)
};

const es_mobile_password_reset_link_expired = /** @type {(inputs: Mobile_Password_Reset_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este enlace para restablecer la contraseña expiró o ya se usó. Solicita uno nuevo.`)
};

/**
* | output |
* | --- |
* | "This password reset link has expired or was already used. Request a new one." |
*
* @param {Mobile_Password_Reset_Link_ExpiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_password_reset_link_expired = /** @type {((inputs?: Mobile_Password_Reset_Link_ExpiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Password_Reset_Link_ExpiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_password_reset_link_expired(inputs)
	return en_mobile_password_reset_link_expired(inputs)
});